// extracted by mini-css-extract-plugin
export default {"loading":"LoadingBox_loading__nx31+","label":"LoadingBox_label__xWxfw"};